import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { Picker } from '../picker';
import { Passenger } from '../../../../models/passengers';

@Component({
  selector: 'ts-party-size-picker',
  templateUrl: './party-size-picker.component.html',
  styleUrls: ['./party-size-picker.component.scss', '../../style.scss']
})
export class PartySizePickerComponent extends Picker implements OnInit, OnChanges {

  @Input() rooms: Passenger[];
  @Input() guestsTotal;

  adultsNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  childsNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  isDropDownOpen: boolean = false;

  @Output() updateRoom = new EventEmitter();
  @Output() removeRoom = new EventEmitter();
  @Output() addRoom = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    // if (changes.rooms) {
    //   this.updateGuestsTotal();
    // }
  }

  handleSelect(roomIndex: number, name: string, value: number) {
    this.updateRoom.emit({
      roomIndex: roomIndex,
      name: name,
      value: value
    });
  }

  toggleDropDown(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isDropDownOpen = !this.isDropDownOpen;
  }

  // updateGuestsTotal() {
  //   let guestsTotal = 0;
  //   for (let index = 0; index < this.rooms.length; index++) {
  //     const room = this.rooms[index];
  //     guestsTotal = guestsTotal + room.adults;
  //     guestsTotal = guestsTotal + room.children;
  //     guestsTotal = guestsTotal + room.infants;
  //   }
  //   this.guestsTotal = guestsTotal;
  // }

}
